import React, { useState } from "react";
import game from '../../assets/Images-new/Game_creation.png'
import blockchain from '../../assets/Images-new/blockchain.png'

const PricingContent = [
  {
    icon: "85",
    packName: "Game Creation",
    features: [
      "We provide versatile experiences on platforms by creating transparent in-game economies, play-to-earn models, and virtual worlds for digital asset ownership with stunning visuals."
    ],
    price: "59.99",
    trialText: "up to 10 user + 1.99 per user",
    image:game
  },
  {
    icon: "86",
    icon2: "159",
    packName: "Blockchain",
    features: [
      "Raiden has expertise in the blockchain based streaming services and decentralized applications. Enabling trust with safe, clear, and verified data transactions over a global network.",
    ],
    price: "29.99",
    trialText: "up to 7 user + 1.99 per user",
    image:blockchain
  },
];

const PricingFive = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <div
      className="row d-flex align-items-start justify-content-center"
      style={{ gap: "30px" }}
    >
      {PricingContent.map((val, i) => (
        <div
        img

          className="col-lg-5 col-11 mb-3 mb-lg-0"
          key={i}
          onMouseEnter={() => setHovered(i)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => setHovered(hovered === i ? null : i)}
          style={{ padding: "0" }}
        >
          
          <div
            style={{
              perspective: "1000px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                minHeight: "250px",
                textAlign: "center",
                transition: "transform 0.6s",
                transformStyle: "preserve-3d",
                transform: hovered === i ? "rotateY(180deg)" : "rotateY(0deg)",
              }}
            >
              
              <div
  style={{
    position: "absolute",
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
    background: "#ffffffff",
    borderRadius: "15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "black",
    fontSize: "20px",
    fontWeight: "600",
    boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
    padding: "20px",
    wordWrap: "break-word",
    overflow: "hidden",
  }}
>
  {val.image && (
    <img
      style={{
        width: "100%",
        height: "100px",
        objectFit: "contain",
        marginBottom: "15px",
      }}
      src={val.image}
      alt={val.packName}
    />
  )}
  <div style={{marginBottom:'40px'}}>{val.packName}</div>
</div>


              
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backfaceVisibility: "hidden",
                 background: "linear-gradient(135deg, #fff7c2, #ffe3a0)",
                  borderRadius: "15px",
                  transform: "rotateY(180deg)",
                  display: "flex",
                  flexDirection: "column",
                 
                  justifyContent: "center",
                  color: "black",
                  fontSize: "16px",
                  fontWeight: "400",
                  padding: "20px",
                  lineHeight: "1.5",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                  wordWrap: "break-word",
                  overflow: "hidden", 
                  
                }}
              >
                {val.features.map((list, idx) => (
                  <p
                    key={idx}
                    style={{
                      margin: 0,
                      fontSize: "15px",
                      lineHeight: "1.4",
                    }}
                  >
                    {list}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}

      
      <div className="text-center mt-4 w-100">
        <a
          href="/request-quote"
          style={{
            background: "linear-gradient(90deg, #F15A24 0%, #F1CC31 100%)",
            border: "none",
            color: "white",
            padding: "12px 28px",
            borderRadius: "50px",
            textDecoration: "none",
            display: "inline-block",
            boxShadow: "0 8px 20px rgba(3, 3, 3, 0.4)",
            transition: "all 0.3s ease",
          }}
        >
          Hire Developer
        </a>
      </div>
    </div>
  );
};

export default PricingFive;
